import { MoveLevel } from '../models';

const MoveDifficulties = [
    MoveLevel.BEGINNER,
    MoveLevel.INTERMEDIATE,
    MoveLevel.ADVANCED
];

export const getMoveDifficulties = () => MoveDifficulties;
